import { ViewChild, Component, Renderer, HostListener } from '@angular/core';
import {
    NavController,
    ViewController,
    NavParams,
    Events } from 'ionic-angular';

import { Keyboard } from '@ionic-native/keyboard';

import { DataService } from '../../services/data';
import { AlertMessager } from '../../lib/alertMessager';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
    selector: 'email-search',
    templateUrl: 'email-search.html'
})
export class EmailSearchPopover {
    @ViewChild('emailSearch') emailSearch;

    searchChangeObservable;
    selecting: boolean = false;

    eventPublished = false;
    callbackEvent: string = '';
    results: any = [];
    searchValue: string = '';
    selectedValue: any;
    staff: boolean = false;
    
    constructor(
                private nav: NavController,
                private _viewCtrl: ViewController,
                private navParams: NavParams,
                private data: DataService,
                private events: Events,
                private renderer: Renderer,
                private alert: AlertMessager,
                private keyboard: Keyboard) {
        this.callbackEvent = this.navParams.get('callback');
        this.results = this.navParams.get('results');
        this.searchValue = this.navParams.get('searchValue');
        this.staff = this.navParams.get('staff');

        if (this.results.length > 0) {
            this.selectedValue = this.results[0];
        } else {
            this.selectedValue = null;
        }
    }

    ionViewDidEnter() {
        const element = this.emailSearch._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            this.renderer.invokeElementMethod(element, 'focus', []);
            this.keyboard.show();
        }, 0);
    }

    onSearchChange(event, searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.searchForEmail(event, searchValue) });
        }

		this.searchChangeObservable.next(searchValue);
    }

	searchForEmail(event, searchValue : string) {
        if (!this.staff) {
            this.data.getEmailSearch(searchValue)
            .then(data => {
                this.results = data;

                if (this.results.length > 0) {
                    this.selectedValue = this.results[0];
                } else {
                    this.selectedValue = null;
                }
            })
            .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
        } else {
            this.data.getStaffSearch(searchValue)
            .then(data => {
                this.results = data;

                if (this.results.length > 0) {
                    this.selectedValue = this.results[0];
                } else {
                    this.selectedValue = null;
                }
            })
            .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
        }
	}

    selectItem(item) {
        if (this.selecting)
            return;

        this.selecting = true;

        this.eventPublished = true;
        this.nav.pop().then(() => { 
            this.selecting = false;
            this.events.publish(this.callbackEvent, item);
         }).catch((err) => console.log("Error popping: ", err));
    }

    ionViewDidLeave() {
        if (!this.eventPublished)
            this.events.publish(this.callbackEvent, null);
    }

    getSearchMessage() {
        if (this.searchValue == undefined || this.searchValue.trim().length == 0)
            return "Please enter an email address.";
        else if (this.results == undefined || this.results.length < 1)
            return "There are no email addresses that match that.";

        return "";
    }

    _bdClick() {
        return this._viewCtrl.dismiss(null, 'backdrop');
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this._viewCtrl.isLast()) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        } else if (ev.keyCode === 38 && this.results.length > 0) {
            if (this.results[0] !== this.selectedValue) {
                let index = this.results.indexOf(this.selectedValue);

                this.selectedValue = this.results[index - 1];                
            }
        } else if (ev.keyCode === 40 && this.results.length > 0) {
            if (this.results[this.results.length - 1] !== this.selectedValue) {
                let index = this.results.indexOf(this.selectedValue);

                this.selectedValue = this.results[index*1 + 1];                
            }
        } else if (ev.keyCode === 13 && this.selectedValue != null) {
            this.selectItem(this.selectedValue);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/search/email-search.ts